import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MetadataLoadingStage, UserContextService } from '../core/services/user-context.service';
import { SharedService } from '../core/services/shared-service';
import { Observable } from 'rxjs';
import { filter, switchMap, map } from 'rxjs/operators';

export const OnboardingGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const userContextService = inject(UserContextService);
  const sharedService = inject(SharedService);

  return sharedService.appInitialized$.pipe(
    filter((initialized) => initialized), // Ensure navigation waits until the app is fully initialized
    switchMap(() => userContextService.OnboardingState$),
    map((onboardingState) => {
      if (onboardingState === 'Ongoing') {
        return true; // Allow all navigation if onboarding is complete
      }
      if (onboardingState === 'Preboarding') {
        const allowedRoutes = ['/onboarding/new-organization', '/onboarding/pricing/'];
        return allowedRoutes.includes(state.url); // Allow only specific routes
      }
      return false; // Block all other cases
    })
  );
};